import { render, staticRenderFns } from "./languageList.vue?vue&type=template&id=8b4a7114&scoped=true"
import script from "./languageList.vue?vue&type=script&lang=js"
export * from "./languageList.vue?vue&type=script&lang=js"
import style0 from "./languageList.vue?vue&type=style&index=0&id=8b4a7114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4a7114",
  null
  
)

export default component.exports